export enum EventAction {
  Reconnect = 0,
  WhatsNew = 1,
  RemindLater = 2,
  OpenLibrary = 3,
  OpenSeries = 4,
  OpenMatching = 5,
  Rescan = 6,
  ScanNow = 7,
  Details = 8,
  OpenMediaIssues = 9,
  Download = 10,
}
